import React, { useState, useEffect, useRef } from 'react'
import { KnovaText } from './KnovaText'
import { blindShuffle } from '../utils/SmartLabelUtils'

export default function KnovaSelect(props) {
  const {
    isPractice,
    Completed,
    isActive,
    optionData,
    optionIndex,
    themeColors,
    themeFont,
    isSideMenu,
    layoutType,
    onOptionSelected,
    selectedOptionData,
    isOutsideClick,
    getCurrentSelectedOption
  } = props

  const { Data } = optionData
  const [dataArray, setDataArray] = useState(blindShuffle(Data))
  const [currentSelectedDropdown, setcurrentSelectedDropdown] = useState(-1)
  const dropdownRef = useRef(null)
  const [dropdownPosition, setDropdownPosition] = useState('bottom') // "bottom" or "top"

  useEffect(() => {
    if (isOutsideClick) {
      setcurrentSelectedDropdown(-1)
    }
  }, [isOutsideClick])

  useEffect(() => {
    if (currentSelectedDropdown === optionIndex) {
      updateDropdownPosition() // Check position on click
    }
    getCurrentSelectedOption(currentSelectedDropdown)
  }, [currentSelectedDropdown])

  // Function to determine dropdown position
  const updateDropdownPosition = () => {
    if (dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect()
      const windowHeight = window.innerHeight // Total window height
      const yPercentage = (rect.top / windowHeight) * 100 // Convert to percentage

      if (yPercentage > 70) {
        setDropdownPosition('top') // Open above if more than 50% of screen height
      } else {
        setDropdownPosition('bottom') // Open below otherwise
      }
    }
  }

  function renderDropdownUI() {
    return (
      <div
        ref={dropdownRef}
        className='dropdown-modal-cont card-shadow'
        style={{
          width: layoutType === 10 ? '100%' : '80%',
          position: 'absolute',
          [dropdownPosition === 'top' ? 'bottom' : 'top']: '100%'
        }}
        // style={{
        //   width: layoutType === 10 ? '100%' : '80%',
        //   bottom: optionIndex > 2 ? '100%' : undefined
        // }}
      >
        {dataArray.map((l, index) => (
          <span
            className='dropdown-list-label-container'
            style={{
              borderBottom: '1px solid #B5B5B5',
              cursor: 'pointer'
            }}
            key={'dpdownOptionList' + index.toString()}
            onClick={(ev) => {
              ev.preventDefault()
              setcurrentSelectedDropdown(-1)
              onOptionSelected(l, optionIndex)
            }}
          >
            <p className='dropdown-list-label'>{l.Answer}</p>
          </span>
        ))}
      </div>
    )
  }

  return (
    <div
      className='knova-select-cont'
      onClick={(event) => {
        if (currentSelectedDropdown === -1) {
          event.preventDefault()
          setcurrentSelectedDropdown(optionIndex)
        }
      }}
    >
      <KnovaText
        contBgColor={themeColors.surfaceVarient}
        contMargin={isSideMenu ? '2px 0px' : '9px 0px'}
        contPadding={isSideMenu ? '1px' : '16px 24px'}
        contBorderColor={
          isPractice || Completed === 1 || !isActive
            ? selectedOptionData.Answer || selectedOptionData.Answer !== ''
              ? selectedOptionData.Value > 0
                ? themeColors.successContainer
                : themeColors.errorContainer
              : themeColors.outlineVarient
            : themeColors.outlineVarient
        }
        contBorderWidth={isSideMenu ? '1px' : '2px'}
        contBorderRadius={isSideMenu ? '2px' : '12px'}
        text={
          selectedOptionData.Answer || selectedOptionData.Answer !== ''
            ? selectedOptionData.Answer
            : 'Select'
        }
        textColor={themeColors.onSurfaceVarient}
        textFontSize={isSideMenu ? '5px' : '16px'}
        textFontFamily={themeFont.bodyFont}
        textFontWeight='400'
        cursor='pointer'
        isIcon={true}
        iconName={'dropdown'}
        iconPosition='end'
        isDown={currentSelectedDropdown > -1 ? false : true}
        iconColor={themeColors.onSurfaceVarient}
        isSideMenu={isSideMenu}
        visibility='visible'
      />
      {currentSelectedDropdown > -1 &&
        currentSelectedDropdown === optionIndex &&
        renderDropdownUI()}
    </div>
  )
}
